import Control from "sap/ui/core/Control";
import { FormatDate } from "akademika/akamont/utils/FormatUtil";
import ObjectStatus from "sap/m/ObjectStatus";
import { BaseLogFormatter } from "./BaseLogFormatter";
import { GetStateForSpecificationStatus } from "akademika/akamont/utils/SpecificationStatusUtil";

export class SpecificationLogFormatter extends BaseLogFormatter {
  generateControlForValue(
    value: string | null | undefined,
    fieldName: string
  ): Control {
    switch (fieldName) {
      case "FromDate":
      case "ToDate":
        return this.generateTextControl(FormatDate(value));
      case "IsDeleted":
        return this.generateTextControl(this.getTextForBooleanValue(value));
      case "Status":
        if (!value) return this.generateTextControl();
        return new ObjectStatus({
          state: GetStateForSpecificationStatus(value),
          text: this._controller.translate(value),
          inverted: true,
        });
      default:
        return this.generateTextControl(value);
    }
  }
}
